import { Component, ComponentFactoryResolver, OnDestroy, OnInit } from '@angular/core';
import { RolesControlService } from '../../../../services/roles-control.service';
import { SwalService } from '../../../../shared/services/swal.service';
import { BroadcastService } from '../../../../shared/services/broadcast.service';
import { NRModalService } from '../../../../shared/modal/services/nrmodal.service';
import { EventModel, EventSubscriptionType, EventType } from '../../../../shared/interfaces/event.model';
import { takeUntil } from 'rxjs/operators';
import { DynamicHostModel } from '../../../../shared/modal/models/dynamic-host.model';
import { Subject } from 'rxjs';
import { CreateEditRolesControllerComponent } from './create-edit-roles-controller/create-edit-roles-controller.component';

@Component({
  selector: 'app-roles-controller',
  templateUrl: './roles-controller.component.html',
  styleUrls: ['./roles-controller.component.scss']
})
export class RolesControllerComponent implements OnInit, OnDestroy {
  dtConfig = {
    config: {
      base: this.rolesControlService,
      api: 'datatable',
      rowsPerPage: 10,
      order: [[1, 'desc']],
      params: {
        key: ''
      }
    },
    columns: [
      {
        title: 'ID',
        field: 'id'
      },
      {
        title: 'Nombre',
        field: 'name'
      }
    ],
    actions: [
      {
        display: 'Editar',
        icon: 'fa-pencil',
        event: 'role.edit',
        conditionality: 'true'
      },
      {
        display: 'Eliminar',
        icon: 'fa-trash',
        event: 'role.delete',
        conditionality: 'true'
      }
    ]
  };

  private atComponentDestroy = new Subject();
  processRolesPermissions(roles: any[]): any[] {
    return roles.map(role => {
      const permissions = Array.isArray(role.permissions)
        ? role.permissions.map(p => p.name).join(', ')
        : 'Sin permisos';
      return { ...role, permissions_text: permissions };
    });
  }
  
  constructor(
    private rolesControlService: RolesControlService,
    private swal: SwalService,
    private broadcast: BroadcastService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private nrModal: NRModalService
  ) { }

  ngOnDestroy(): void {
    this.atComponentDestroy.next();
    this.atComponentDestroy.unsubscribe();
  }

  ngOnInit(): void {
    this.broadcast
      .onEvent(EventSubscriptionType.TYPE, EventType.MODAL)
      .pipe(takeUntil(this.atComponentDestroy))
      .subscribe((event: EventModel) => {
        const props = this.prepareProps(event);
        if (props) {
          this.nrModal.open(props, 'md');
        }
      });
  }

  prepareProps(event: EventModel): any {
    const props: DynamicHostModel = new DynamicHostModel();
    props.instantiated = false;
    props.modalModel = {
      component: null,
      componentFactoryResolver: this.componentFactoryResolver,
      data: event.data.item || {}
    };
  
    switch (event.name) {
      case 'role.add':
        props.modalModel.component = CreateEditRolesControllerComponent;
        props.modalModel.modalConfiguration = {
          title: 'Agregar Rol'
        };
        break;

      case 'role.edit':
        props.modalModel.component = CreateEditRolesControllerComponent;
        props.modalModel.modalConfiguration = {
          title: 'Editar Rol'
        };
        break;

      case 'role.delete':
        this.delete(event.data);
        return false;
    }
  
    if (!props.modalModel.component) return false;
  
    return props;
  }

  add(): void {
    this.broadcast.fire({
      name: 'role.add',
      type: EventType.MODAL,
      data: {}
    });
  }

  delete(data): void {
    const swalParams = {
      title: '¿Estás seguro de querer eliminar este rol?',
      text: 'El rol será eliminado permanentemente.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    };

    this.swal.warning(swalParams).then(result => {
      if (result.value) {
        this.rolesControlService.delete(data.item.id).subscribe(response => {
          this.swal.success({ title: 'Rol eliminado con éxito' }).then(() => {
            this.broadcast.reloadDataTable();
          });
        }, error => {
          console.error('Error al eliminar:', error);
          this.swal.error('Ocurrió un error al intentar eliminar el rol');
        });
      }
    });
  }
}
